// extracted by mini-css-extract-plugin
export default {"container":"OTPTimer_container__6ueLZ","textNumber":"OTPTimer_textNumber__tlOlL","text":"OTPTimer_text__u4xHx"};